import React, { useEffect, useState } from "react";
import {
  ButtonWrapper,
  Description,
  RootContainer,
  Rule,
  RuleTitle,
  RuleWrapper,
  SkipButton,
  SkipButtonContainer,
  Title,
  Button,
  TopImage,
} from "./Share.style";
import { Alert } from "@components";
import { useTranslation } from "react-i18next";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { PUBLIC_ROUTE, PRIVATE_ROUTE } from "@router/route.constants";
import {
  SHARE_TYPES,
  ENGLISH_LANGUAGE_CODE_LK,
  BURMESE_LANGUAGE_CODE_LK,
  SHARE_ID_LK,
} from "@constants";
import { useDispatch } from "react-redux";
import { localStorage } from "@utils";
import { api } from "@api";
import { openAlert, closeAlert } from "@redux/app/appSlice";
import {
  ShareRegisterIMG,
  SharePMIMG,
  ShareProfileIMG,
  ShareSpinIMG,
  ShareTopUpIMG,
  ShareWithdrawIMG,
} from "@assets";
import ShareModal from "./ShareModal/ShareModal";
import copy from "copy-to-clipboard";

const Share = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { state } = useLocation();

  const share_type = state?.share_type;
  const is_spin_home = state?.is_spin_home;
  const transactions = state?.transactions;
  const amount = state?.amount;

  const [rules, setRules] = useState("");
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [link, setLink] = useState('');
  const userPreferedLanguage = localStorage.getUserPreferedLanguage();
  const ruleText =
    userPreferedLanguage === ENGLISH_LANGUAGE_CODE_LK
      ? rules?.tc_en
      : userPreferedLanguage === BURMESE_LANGUAGE_CODE_LK
        ? rules?.tc_mm
        : rules?.tc_ch;

  useEffect(() => {
    if (!state) {
      return;
    }
    getTermsAndConditons();

    return () => {
      dispatch(closeAlert());
    }

    // eslint-disable-next-line
  }, []);

  const getShareLink = (successCallback) => {
    if (!loading) {
      setLoading(true);
      api
        .getShareLink({ type: share_type })
        .then(({ share: { share_id } }) => {
          setLoading(false);

          if(!share_id){
            showAlert({
              message: t("common.featureUnavailableMsg"),
              isError: true,
              successCallback: () => {
                if(share_type === SHARE_TYPES.NORMAL){
                  navigate(`/${PUBLIC_ROUTE.HOME}/${PUBLIC_ROUTE.PROFILE}`)
                }
              }
            })
            return
          }

          const domain = window.location.hostname;
          successCallback(
            `${domain}/${PUBLIC_ROUTE.SHARE_REGISTER}?${SHARE_ID_LK}=${share_id}`
          );
        })
        .catch((errorMsg) => {
          setLoading(false);
          showAlert({
            message: errorMsg,
            isError: true,
          });
        });
    }
  };

  const getTermsAndConditons = () => {
    api
      .getShareTNC({ type: share_type })
      .then(({ tnc }) => {
        setRules(tnc);
      })
      .catch(() => { });
  };

  const skip = () => {
    switch (share_type) {
      case SHARE_TYPES.WITHDRAW:
        return navigate(`/${PRIVATE_ROUTE.TRANSACTIONS}`, { replace: true });

      case SHARE_TYPES.TOPUP:
        return navigate(`/${PUBLIC_ROUTE.HOME}/${PRIVATE_ROUTE.WALLET}`, { replace: true });

      case SHARE_TYPES.SPIN:
        return navigate(
          is_spin_home
            ? `/${PUBLIC_ROUTE.SPIN_HOME}`
            : `/${PUBLIC_ROUTE.SPIN_HISTORY}`,
          { replace: true }
        );

      case SHARE_TYPES.POCKET_MONEY:
        return navigate(`/${PUBLIC_ROUTE.POCKET_MONEY}`, {
          replace: true,
          state: {
            transactions,
            amount,
          },
        });

      case SHARE_TYPES.REGISTER:
        return navigate(`/${PRIVATE_ROUTE.WITHDRAW_ACCOUNTS}`, { replace: true });

      case SHARE_TYPES.NORMAL:
        return navigate(`/${PUBLIC_ROUTE.HOME}/${PUBLIC_ROUTE.PROFILE}`, { replace: true });

      default:
        return;
    }
  };

  const showImage = () => {
    switch (share_type) {
      case SHARE_TYPES.WITHDRAW:
        return ShareWithdrawIMG;

      case SHARE_TYPES.TOPUP:
        return ShareTopUpIMG;

      case SHARE_TYPES.SPIN:
        return ShareSpinIMG;

      case SHARE_TYPES.POCKET_MONEY:
        return SharePMIMG;

      case SHARE_TYPES.REGISTER:
        return ShareRegisterIMG;

      case SHARE_TYPES.NORMAL:
        return ShareProfileIMG;

      default:
        return ShareRegisterIMG;
    }
  };

  const copyText = (link) => {
    try {
      let isCopied = copy(link);
      if (isCopied) {
        showAlert({
          message: t("common.copied"),
        });
      }
      else {
        showAlert({
          message: t("share.permissionMsg"),
          isError: true,
          successCallback: () => copyText(link),
        });
      }

    } catch (error) {
      console.log(error);
    }
  };

  const handleCopyClicked = () => {
    getShareLink((link) => {
      copyText(link);
    });
  };

  const handleShareClicked = () => {
    getShareLink((link) => {
      setLink(link);
      setOpen(true);
    });
  };

  const showAlert = (data) => {
    dispatch(openAlert(data));
  };

  if (!state) {
    return <Navigate to={`/${PUBLIC_ROUTE.HOME}`} />;
  }

  return (
    <RootContainer>
      <SkipButtonContainer>
        <SkipButton onClick={skip}> {t("common.skip")} </SkipButton>
      </SkipButtonContainer>

      <TopImage src={showImage()} />

      <Title>{t("share.fixedPromoText1")}</Title>
      <Description>
        {
          `${t("share.fixedPromoText2").split("-")[0]}
          ${t("common.appName")} 
          ${t("share.fixedPromoText2").split("-")[1]}`}
      </Description>

      <ButtonWrapper>
        <Button
          type="primary"
          copy={"copy"}
          onClick={handleCopyClicked}
        >
          {t("share.copyLink")}
        </Button>
        <Button
          type="secondary"
          copy={"share"}
          onClick={handleShareClicked}
        >
          {t("share.shareNow")}
        </Button>
      </ButtonWrapper>

      <RuleWrapper>
        <RuleTitle>{t("common.termsAndConditions")}</RuleTitle>
        <Rule
        dangerouslySetInnerHTML={{
          __html: ruleText,
        }}
      />
      </RuleWrapper>

      <Alert />
      <ShareModal
        link={link}
        open={open}
        handleClose={() => setOpen(false)}
        copy={copyText}
      />
    </RootContainer>
  );
};

export default Share;